import axios from "axios";
import { endpointApi } from "../../utils";
import { logout } from "./auth.action";
import { EXPENSE_LIST_FAIL, EXPENSE_LIST_REQUEST, EXPENSE_LIST_SUCCESS } from "../constats/expense.constant";

export const getExpenses = (location=null, navigate=null, year=(new Date()).getFullYear()) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: EXPENSE_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }expenses${ location && location.search && location.search.length > 0 ? location.search + "&year=" + year : "?year=" + year }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: EXPENSE_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: EXPENSE_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: EXPENSE_LIST_FAIL,
                payload: err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}